var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Slider'),_c('TrackTrace'),_c('Alliance'),_c('Wblog'),_c('CoreService')],1)}
var staticRenderFns = []

export { render, staticRenderFns }